import { render, staticRenderFns } from "./MailSegnalazioneReview.vue?vue&type=template&id=528b0965&scoped=true"
import script from "./MailSegnalazioneReview.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneReview.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneReview.vue?vue&type=style&index=0&id=528b0965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b0965",
  null
  
)

export default component.exports